var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3675_140183)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29688 5C3.29688 4.65482 3.5767 4.375 3.92187 4.375H17.2552C17.6004 4.375 17.8802 4.65482 17.8802 5C17.8802 5.34518 17.6004 5.625 17.2552 5.625H3.92187C3.5767 5.625 3.29688 5.34518 3.29688 5Z",
    fill: "#8C8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29688 10C3.29688 9.65482 3.5767 9.375 3.92187 9.375H17.2552C17.6004 9.375 17.8802 9.65482 17.8802 10C17.8802 10.3452 17.6004 10.625 17.2552 10.625H3.92187C3.5767 10.625 3.29688 10.3452 3.29688 10Z",
    fill: "#8C8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29688 15C3.29688 14.6548 3.5767 14.375 3.92187 14.375H17.2552C17.6004 14.375 17.8802 14.6548 17.8802 15C17.8802 15.3452 17.6004 15.625 17.2552 15.625H3.92187C3.5767 15.625 3.29688 15.3452 3.29688 15Z",
    fill: "#8C8FA4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3675_140183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.587891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowIcon);
export default __webpack_public_path__ + "static/media/row-icon.e78615e71bb2c84e8e91b7fcc9c03106.svg";
export { ForwardRef as ReactComponent };